import { useGetAccessStatusQuery, type AccessState } from '@/store/billingApi';

export interface UseAccessStatusResult {
  state: AccessState;
  graceEndsAt: string | null;
  isBlocked: boolean;
  isGrace: boolean;
}

/**
 * Wraps the access-status query with FAIL-OPEN semantics: while the request is
 * loading, has errored, or returned nothing, we treat the tenant as `Active`
 * (full access, no banner, no block). This guarantees we never lock out a user
 * because of a transient/network/serialization problem with the access-status
 * endpoint. Only an explicit `GraceWarning` / `Blocked` from the backend gates
 * the app.
 */
export function useAccessStatus(): UseAccessStatusResult {
  const { data } = useGetAccessStatusQuery();

  const state: AccessState = data?.state ?? 'Active';
  const graceEndsAt = data?.graceEndsAt ?? null;

  return {
    state,
    graceEndsAt,
    isBlocked: state === 'Blocked',
    isGrace: state === 'GraceWarning',
  };
}
